import React, { useEffect, useRef, useState } from 'react';
import Header from '../../../components/header';
import Layout from '../../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../components/icons';
import Drawer from '../../../components/Drawer';
import { Dropdown, Menu } from '../../../components/Dropdown';
import Button from '../../../components/elements/button';
import { DATE_FORMAT, PAGE_SIZE } from '../../../_common/constant';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import { downloadExcel, downloadPDF, showLocalDate } from '../../../_common/functions';
import Loader from '../../../components/loader';
import { titleCell } from '../../../components/elements/function';
import toast from 'react-hot-toast';
import { useSagesApi } from '../../../store/api/hooks/sageApiHook';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';

const AssetReportList: React.FC = () => {
    const sageApi: any = useSagesApi();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [rowData, setrowData] = useState<any>(null);
    const [assetSubGroupName, setAssetSubGroupName] = useState<any[]>([]);
    const [editData, setEditData] = useState<any>(null);
    const [isExporting, setIsExporting] = useState<boolean>(false);
    const assetsAPI = useAssetsApi();

    const onGridReady = (params: any) => {
    };
    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };
    const columnDefs = [
        { headerName: 'Asset Code', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', pinned: 'left', width: 180, cellRenderer: titleCell, headerTooltip: 'Asset Code' },
        { headerName: 'Sage Asset ID', field: 'sageAssetID', headerClass: 'bg-[#f0f0f0]', width: 130, cellRenderer: titleCell, headerTooltip: 'Sage Asset ID' },
        { headerName: 'Asset Name (CMMS)', field: 'assetNameCMMS', headerClass: 'bg-[#f0f0f0]', minWidth: 200, flex: 1, cellRenderer: titleCell, headerTooltip: 'Asset Name (CMMS)' },
        { headerName: 'Facility (CMMS)', field: 'facilityCMMS', headerClass: 'bg-[#f0f0f0]', width: 150, cellRenderer: titleCell, headerTooltip: 'Facility (CMMS)' },
        { headerName: 'Sage Entity for Dep\'n Purposes', field: 'sageEntityforDepNPurposes', headerClass: 'bg-[#f0f0f0]', width: 220, cellRenderer: titleCell, headerTooltip: 'Sage Entity for Depreciation Purposes' },
        { headerName: 'Sage Account for Dep\'n (Expense)', field: 'sageAccountforDepNExpense', headerClass: 'bg-[#f0f0f0]', width: 220, cellRenderer: titleCell, headerTooltip: 'Sage Account for Depreciation (Expense)' },
        { headerName: 'Sage Account for Accumulated Dep\'n (Balance Sheet)', field: 'sageAccountforAccumulatedDepNBalanceSheet', headerClass: 'bg-[#f0f0f0]', width: 280, cellRenderer: titleCell, headerTooltip: 'Sage Account for Accumulated Depreciation (Balance Sheet)' },
        { headerName: 'Sage Account for Assets (Balance Sheet)', field: 'sageAccountforAssetsBalanceSheet', headerClass: 'bg-[#f0f0f0]', width: 250, cellRenderer: titleCell, headerTooltip: 'Sage Account for Assets (Balance Sheet)' },
        { headerName: 'Description (optional)', field: 'descriptionoptional', headerClass: 'bg-[#f0f0f0]', width: 180, cellRenderer: titleCell, headerTooltip: 'Description (optional)' },
        { headerName: 'Vehicle', field: 'vehicle', headerClass: 'bg-[#f0f0f0]', width: 100, cellRenderer: titleCell, headerTooltip: 'Vehicle' },
        { headerName: 'Department', field: 'department', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Department' },
        { headerName: 'Ownership Type', field: 'ownershipType', headerClass: 'bg-[#f0f0f0]', width: 130, cellRenderer: titleCell, headerTooltip: 'Ownership Type' },
        { headerName: 'Asset Group', field: 'assetGroup', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Asset Group' },
        { headerName: 'Purchase Date', field: 'purchasedate', headerClass: 'bg-[#f0f0f0]', width: 130, cellRenderer: titleCell, headerTooltip: 'Purchase Date' },
        { headerName: 'Disposal Date', field: 'disposalDate', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Disposal Date' },
        { headerName: 'Disposal Value', field: 'disposalValue', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Disposal Value' },
        { headerName: 'Disposal Type', field: 'disposalType', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Disposal Type' },
        { headerName: 'Purchase Cost', field: 'purchasecost', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Purchase Cost' },
        { headerName: 'Vendor', field: 'vendorName', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Vendor' },
        { headerName: 'Service Vendor', field: 'serviceVendor', headerClass: 'bg-[#f0f0f0]', width: 130, cellRenderer: titleCell, headerTooltip: 'Service Vendor' },
        { headerName: 'Manufacturer', field: 'manufacturer', headerClass: 'bg-[#f0f0f0]', width: 130, cellRenderer: titleCell, headerTooltip: 'Manufacturer' },
        { headerName: 'Model', field: 'model', headerClass: 'bg-[#f0f0f0]', width: 100, cellRenderer: titleCell, headerTooltip: 'Model' },
        { headerName: 'Part No', field: 'partNo', headerClass: 'bg-[#f0f0f0]', width: 100, cellRenderer: titleCell, headerTooltip: 'Part Number' },
        { headerName: 'Registration no/Serial Number', field: 'registrationnoSerialNumber', headerClass: 'bg-[#f0f0f0]', width: 200, cellRenderer: titleCell, headerTooltip: 'Registration Number/Serial Number' },
        { headerName: 'Current Status', field: 'currentStatus', headerClass: 'bg-[#f0f0f0]', width: 200, cellRenderer: titleCell, headerTooltip: 'Current Status' },
        { headerName: 'VIN', field: 'vin', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell, headerTooltip: 'Vehicle Identification Number' },
        { headerName: 'Title Number', field: 'titleNumber', headerClass: 'bg-[#f0f0f0]', width: 180, cellRenderer: titleCell, headerTooltip: 'Title Number' },
        { headerName: 'Title County', field: 'titleCounty', headerClass: 'bg-[#f0f0f0]', width: 180, cellRenderer: titleCell, headerTooltip: 'Title County' },
        { headerName: 'Useful Life Book (Years)', field: 'usefulLifeBookYears', headerClass: 'bg-[#f0f0f0]', width: 180, cellRenderer: titleCell, headerTooltip: 'Useful Life Book (Years)' },
        { headerName: 'Convention', field: 'convention', headerClass: 'bg-[#f0f0f0]', width: 180, cellRenderer: titleCell, headerTooltip: 'Convention' },
        { headerName: 'Dep\'n Method (Book) - Always Straight Line', field: 'depMethodBook', headerClass: 'bg-[#f0f0f0]', width: 350, cellRenderer: titleCell, headerTooltip: 'Depreciation Method (Book) - Always Straight Line' },
        { headerName: 'Useful Life Tax (Years)', field: 'usefulLifeTaxYears', headerClass: 'bg-[#f0f0f0]', width: 170, cellRenderer: titleCell, headerTooltip: 'Useful Life Tax (Years)' },
        { headerName: 'Tax Convention (Half Year, Mid Quarter, Mid Month)', field: 'taxConvention', headerClass: 'bg-[#f0f0f0]', width: 350, cellRenderer: titleCell, headerTooltip: 'Tax Convention (Half Year, Mid Quarter, Mid Month)' },
        { headerName: 'Dep\'n Method (Tax)', field: 'depMethodTax', headerClass: 'bg-[#f0f0f0]', width: 150, cellRenderer: titleCell, headerTooltip: 'Depreciation Method (Tax)' },
        { headerName: 'Last Inspection', field: 'lastInspection', headerClass: 'bg-[#f0f0f0]', width: 200, cellRenderer: titleCell, headerTooltip: 'Last Inspection' },
    ];

    const GetAssetReportList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        setrowData(null);
        
        assetsAPI.getAssetsReportList(payload, (resp: any) => {
            const mappingList = resp.assetDetailsList ?? [];
            setrowData(mappingList);
            setTotalRecords(resp.totalRecord);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });

    };

    useEffect(() => {
        GetAssetReportList();
    }, [currentPage, searchParam]);

    const ExportAssetReportExcel = async () => {
        const payload = {
        };
        
        setIsExporting(true);
        assetsAPI.ExportAssetReportcsv(
            payload,
            (resp: any) => { 
                downloadExcel(resp, 'assets_report');
                toast.success('Asset report exported successfully!');
                setIsExporting(false);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error || 'Failed to export asset report');
                setIsExporting(false);
            }
        );
    };


    return (
        <Layout>
            <Header title="Assets Report List" back="/reports" >
                <Header.Right>
                    <Button 
                        theme='primary' 
                        onClick={ExportAssetReportExcel}
                        disabled={isExporting}
                    >
                        {isExporting ? 'Exporting...' : 'Export Excel'}
                    </Button>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} placeholder='Search by Group code' /> */}
            </div>
            <div className='bg-[#FAFAFA] w-full'>
                <div className="ag-theme-alpine px-4 w-full h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any} // Pass columnDefs
                        rowData={rowData || []} // Pass rowData
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        pagination={false}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
        </Layout>
    );
};
export default AssetReportList;